module.exports = __webpack_public_path__ + "static/media/not-accepted-icon.fd16da15.svg";